import domready from 'domready'
import GetScoutedFormController from './controllers/get-scouted-form-controller'

export default function initGetScouted (breakpoints) {
  domready(() => {
    const formElement = document.querySelector('#get-scouted-form')

    if (formElement) {
      // eslint-disable-next-line no-new
      new GetScoutedFormController(formElement)
    }
  })
}
